import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { PCTProvinceGroupingExtension } from 'app/models/extensions/p-c-t-province-grouping-extension.model';
import { PCTRegionCode } from 'app/models/p-c-t-region-code.model';
import { ProcessedEntity } from 'app/models/processed-entity.model';
import { MRMValidators } from '@mrm/core';

export class PCTProvinceGrouping extends PCTProvinceGroupingExtension {
  pctProvinceGroupingDBID: number = 0;
  pctProvinceCode: string = null;
  englishDescription: string = null;
  frenchDescription: string = null;
  pctRegionCodeDBID: number = 0;
  isActive?: boolean = null;
  orderNumber: number = 0;
  showInReportSelection: boolean = false;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  pctRegionCode: PCTRegionCode = null;
  processedEntities: ProcessedEntity[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      pctProvinceGroupingDBID: new FormControl({ value: 0, disabled: disableAll }),
      pctProvinceCode: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(4)]),
      englishDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      pctRegionCodeDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      isActive: new FormControl({ value: null, disabled: disableAll }),
      orderNumber: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      showInReportSelection: new FormControl({ value: false, disabled: disableAll }, [Validators.required]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      processedEntities: new FormArray([])
    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'pctregioncode':
            form.addControl('pctRegionCode', PCTRegionCode.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of PCTProvinceGrouping. Please use one of the following navigational property: 'pctRegionCode'`);
        }
      }
    }

    return form;
  }
}